import { Directive, EventEmitter, Input, Output } from '@angular/core';

export type SortDirection = 'ASC' | 'DESC' | '';
const rotate: { [key: string]: SortDirection } = { 'ASC': 'DESC', 'DESC': '', '': 'ASC' };

export interface SortEvent {
  by: string;
  dir: SortDirection;
}

@Directive({
  selector: 'div[sortable]',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '(click)': 'rotate()'
  }
})
export class SortableHeader {

  @Input() sortable: string = null;
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    if (this.sortable) {
      this.direction = rotate[this.direction];
      this.sort.emit({ by: this.sortable, dir: this.direction });
    }
  }
}